module.exports = __webpack_public_path__ + "img/favourite.b0b23ee.svg";